/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Collection_2Inputs */

const en_flow_collection_2 = /** @type {(inputs: Flow_Collection_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow prices it and prepares every SKU in Backstage.`)
};

/**
* | output |
* | --- |
* | "Tomorrow prices it and prepares every SKU in Backstage." |
*
* @param {Flow_Collection_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_collection_2 = /** @type {((inputs?: Flow_Collection_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Collection_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_collection_2(inputs)
});